
import { supabase } from "@/integrations/supabase/client";
import { Json } from "@/integrations/supabase/types";
import { FormData } from "./types";

export function useUpdateUser(fetchUsers: () => void) {
  const updateUser = async (
    userId: string,
    formData: FormData,
    onFinish?: () => void
  ) => {
    try {
      if (formData.constituency_code && formData.country_code) {
        const { data, error } = await supabase
          .from("constituencies")
          .select("code")
          .eq("code", formData.constituency_code)
          .eq("country_code", formData.country_code)
          .single();
        if (error || !data) {
          console.error("The selected constituency does not belong to the selected country");
          return;
        }
      }
      const updateBody: any = {
        role: formData.role,
        country_code: formData.country_code || null,
        constituency_code: formData.constituency_code || null,
        verified: formData.verified,
        name: formData.name,
        phone_number: formData.phone_number,
      };
      if (formData.demographics !== undefined) {
        updateBody.demographics = formData.demographics === null ? null : (formData.demographics as unknown as Json);
      }
      const { error } = await supabase
        .from("profiles")
        .update(updateBody)
        .eq("id", userId);
      if (error) throw error;
      console.log(`User ${userId} updated successfully`);
      fetchUsers();
      if (onFinish) onFinish();
    } catch (error: any) {
      console.error(error.message || "Failed to update user");
    }
  };

  return { updateUser };
}
